import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news/index.vue'),
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/news/:id/:time',
    name: 'h5-news',
    component: () => import('../views/news/index.vue'),
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/news'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
